import { Card, CardContent } from "@/components/ui/card";
import { Hand, Wand2 } from "lucide-react";

interface InitialStepProps {
  onModeSelect: (mode: 'guided' | 'manual') => void;
}

export const InitialStep = ({ onModeSelect }: InitialStepProps) => {
  return (
    <div className="text-center">
      <h3 className="text-lg font-semibold mb-2">How would you like to start?</h3>
      <p className="text-muted-foreground mb-6">
        Choose a path that suits your deck-building style.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto">
        <Card 
          className="cursor-pointer hover:border-primary transition-all"
          onClick={() => onModeSelect('guided')}
        >
          <CardContent className="p-6 text-center">
            <Wand2 className="w-10 h-10 text-primary mx-auto mb-4" />
            <h4 className="font-semibold text-base mb-2">Help me build</h4>
            <p className="text-sm text-muted-foreground">
              Get personalized suggestions for commanders and cards based on your favorite colors.
            </p>
          </CardContent>
        </Card>
        <Card 
          className="cursor-pointer hover:border-primary transition-all"
          onClick={() => onModeSelect('manual')}
        >
          <CardContent className="p-6 text-center">
            <Hand className="w-10 h-10 text-primary mx-auto mb-4" />
            <h4 className="font-semibold text-base mb-2">Let me choose</h4>
            <p className="text-sm text-muted-foreground">
              Take full control and manually select your commander, colors, and strategy.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};